import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface Market {
    id: number;
    name: string;
    code: string;
}

@Injectable({
    providedIn: 'root'
})
export class MarketService {

    private readonly http = inject(HttpClient);

    private readonly baseUrl =
        '/api/v1/companies';

    getMarkets(
        companyId: number
    ): Observable<Market[]> {
        return this.http.get<Market[]>(
            `${this.baseUrl}/${companyId}/markets`
        );
    }

    getMarket(
        id: number
    ): Observable<Market> {
        return this.http.get<Market>(
            `${this.baseUrl}/${id}`
        );
    }
}